<template>
    <div class="page">
        <ion-grid fixed v-if="vehicle">
            <ion-row class="rectangle">
                <ion-col>
                    <ion-row align-items-stretch>
                        <ion-col size="12" size-md="4" class="col-padding">
                            <span class="vh-name">
                                <img
                                v-if="vehicle.type.id === 'TW'"
                                class="vh-icon"
                                src="/assets/images/vehicles/335024.png"
                                />
                                <img
                                v-if="vehicle.type.id == 'FW'"
                                class="vh-icon"
                                src="/assets/images/vehicles/846338.png"
                                />
                                <img
                                v-if="vehicle.type.id == '3W'"
                                class="vh-icon"
                                src="/assets/images/vehicles/rickshaw.png"
                                />
                                <img
                                v-if="vehicle.type.id == 'BUS'"
                                class="vh-icon"
                                src="/assets/images/vehicles/bus.png"
                                />
                                <img
                                v-if="vehicle.type.id == 'TRUCK'"
                                class="vh-icon"
                                src="/assets/images/vehicles/truck.png"
                                />
                                {{vehicle.regNo}}
                            </span>
                            <br />
                            <span class="vh-model-make">{{vehicle.make.name}}&nbsp;{{vehicle.model.name}}</span>
                        </ion-col>
                    </ion-row>
                    <hr />
                    <ion-row align-items-stretch>
                        <ion-col size="12" size-md="3" class="col-padding">
                            <ion-label class="title">Vehicle Make</ion-label>
                            <br />
                            <ion-label class="sub-title">{{vehicle.make.name}}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="3" class="col-padding">
                            <ion-label class="title">Vehicle Model</ion-label>
                            <br />
                            <ion-label class="sub-title">{{vehicle.model.name}}</ion-label>
                        </ion-col>
                        <!-- SCMT 2.0 Migration start -->
                        <!-- <ion-col size="12" size-md="3" class="col-padding">
                            <ion-label class="title">Year Of Manufacture</ion-label>
                            <br />
                            <ion-label class="sub-title">{{vehicle.yearOfManufacturing}}</ion-label>
                        </ion-col> -->
                        <!-- SCMT 2.0 Migration end -->
                        <ion-col size="12" size-md="3" class="col-padding">
                            <ion-label class="title">Vehicle Reg.No/VIN</ion-label>
                            <br />
                            <ion-label class="sub-title">{{vehicle.regNo}}</ion-label>
                        </ion-col>
                        <!-- SCMT 2.0 Migration start -->
                        <!-- <ion-col size="12" size-md="3" class="col-padding">
                            <ion-label class="title">Socket Type</ion-label>
                            <br />
                            <ion-label class="sub-title">{{vehicle.socketType.name}}</ion-label>
                        </ion-col> -->
                        <!-- SCMT 2.0 Migration end -->
                        <ion-col size="12" size-md="3" class="col-padding" v-if="vehicle.onboardPower != null">
                            <ion-label class="title">Onboard Power</ion-label>
                            <br />
                            <ion-label class="sub-title">{{vehicle.onboardPower}}</ion-label>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="rectangle" v-if="reservations && reservations.length > 0">
                <ion-col>
                    <h4 style="text-align: center;">Reservation History</h4>
                    <ion-row align-items-stretch>
                        <ion-col
                            ion-no-margin
                            size="12"
                            size-md="4"
                            v-for="(reservation, index) in reservations"
                            :key="index"
                        >
                            <ion-card @click="viewReservation(reservation.id)">
                                <ion-card-content class="vh-content">
                                    <ion-row>
                                        <ion-col text-left size="6">
                                            <ion-label class="book-ref">{{reservation.refNo}}</ion-label>
                                        </ion-col>
                                        <ion-col text-right size="6">
                                            <ion-label class="book-day">
                                                <!-- {{reservation.slot.startsOn | dateFormat('DD/MMM/YYYY HH:mm')}} -->
                                                {{ changeDateFormatWithTime(reservation.slot.startsOn) }}
                                                <br />
                                                <!-- {{reservation.slot.endsOn | dateFormat('DD/MMM/YYYY HH:mm')}} -->
                                                 <!-- below code is commented on 13-05-2025 as per siva sir request end date and time is hided -->
                                                <!-- {{ changeDateFormatWithTime(reservation.slot.endsOn) }} -->
                                            </ion-label>
                                        </ion-col>
                                    </ion-row>
                                    <hr />
                                    <ion-row>
                                        <ion-col text-left size="8">
                                            <ion-label class="book-station">{{reservation.station.name}}<span v-if="reservation.station.rating != 0">&nbsp;{{reservation.station.rating}}&nbsp;<ion-icon class="star-rating" :icon="star"></ion-icon></span></ion-label>
                                            <br />
                                            <ion-label
                                                class="sub-title"
                                            >{{reservation.station.address.line1}}, {{reservation.station.address.city}}</ion-label>
                                        </ion-col>
                                        <ion-col class="ion-text-center" size="4">
                                            <!-- <ion-label v-if="reservation.status.id === 'C'"
                                            class="book-amount"
                                            >&#8377; {{(reservation.commercial.actual ? reservation.commercial.actual.nettCost : reservation.commercial.estimated.nettCost)}}</ion-label> -->
                                            <br />
                                            <ion-label
                                                class="status-medium-rc"
                                                v-bind:class="[{'open': reservation.status.id === 'O'}, {'cancelled': reservation.status.id === 'X'}, {'wip': reservation.status.id === 'P'}, {'expired': reservation.status.id === 'E'}, {'completed': reservation.status.id === 'C'}]"
                                            >{{reservation.status.name}}</ion-label>
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col>
                                            <ion-label
                                            class="book-amount"
                                            >Estimated Amount &#8377; {{(reservation.commercial.actual ? reservation.commercial.actual.nettCost : reservation.commercial.estimated.nettCost)}}</ion-label> 
                                        </ion-col>
                                    </ion-row>
                                </ion-card-content>
                            </ion-card>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
        </ion-grid>
        <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonGrid, IonRow, IonCol, IonLabel, IonCard, IonCardContent, IonSpinner } from "@ionic/vue";
import moment from "moment";
import { VehicleService } from "../../service/vehicle/vehicle.service";
import { EVCStationReservationService } from "../../service/evcstation/reservation.service";
import { ToastUtils } from "../../util/toast-utils";
import { migratedTryParseServiceError } from "../../service";
import { LocalStorage } from "../../data/localstorage";
import { Vehicle } from "../../entity/vehicle/vehicle";
import { star } from "ionicons/icons"

export default defineComponent ({
    name: 'eVehicleView',
    components: {
        IonGrid, IonRow, IonCol, IonLabel, IonCard, IonCardContent, IonSpinner
    },
    data() {
        return {
            star,
            vehicle: null,
            reservations: [],
            loaderTab: true
        }
    },
    async mounted() {
        try {
            if(this.$route.params.vehicleId != 'R') {
                this.vehicle = await new VehicleService().vehicleWithId(
                    this.$route.params.vehicleId
                );
                
                this.reservations = await new EVCStationReservationService().reservationsMadeByUserForVehicle(
                    new LocalStorage().user,
                    new Vehicle(this.$route.params.vehicleId, "", "", "", "", "", ""),
                    0,
                    100
                );
                this.loaderTab = false;
            }
            this.loaderTab = false;
        } catch(error) {
            this.loaderTab = false;
            // new ToastUtils().presentToast(error.response.data.errors[0].detail);
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
        }
        
    },
    methods: {
        changeDateFormatWithoutTime(dateValue) {
            if(dateValue != null) {
                return moment(dateValue).format('DD/MMM/YYYY')
            }
        },
        changeDateFormatWithTime(dateValue) {
            if(dateValue != null) {
                return moment(dateValue).format('DD/MMM/YYYY HH:mm')
            }
        },
        editVehicle() {
            this.$parent.editVehicle();
            // this.$router.push({
            //   name: "eVehicleEdit",
            //   params: { vehicleId: this.vehicle.id }
            // });
        },
        viewReservation(bookingId) {
            localStorage.setItem("myevid", this.vehicle.id)
            this.$router.push({
                name: "myReservationView",
                params: { bookingId: bookingId }
            });
        }
    }
})
</script>

<style scoped>
h4 {
  height: 17px;
  text-align: left;
  font-family: "Roboto Bold";
  font-size: 14px;
  letter-spacing: 0;
  color: #21315d;
  opacity: 1;
}
.vh-name {
  text-align: left;
  font-family: "Roboto Bold";
  font-size: 15px;
  letter-spacing: 0;
  color: #21315d;
  opacity: 1;
  vertical-align: middle;
  display: inline-block;
}
.vh-icon {
  height: 17px;
  width: 33px;
  vertical-align: middle;
  display: inline-block;
  clear: left;
}
.vh-model-make {
  margin-left: 33px;
  text-align: left;
  font-family: "Roboto";
  font-size: 14px;
  letter-spacing: 0;
  color: #000000;
  opacity: 0.5;
  padding: 5px;
}
.title {
  text-align: left;
  font-family: "Roboto Medium";
  font-size: 14px;
  letter-spacing: 0;
  color: #202020;
  opacity: 1;
}
.sub-title {
  text-align: left;
  font-family: "Roboto";
  font-size: 14px;
  letter-spacing: 0;
  color: #202020;
  opacity: 0.5;
  text-overflow: ellipsis;
}
.history-content {
  /* top: 326px;
left: 259px;
width: 355px;
height: 107px; */
  border: 1px solid #0000001a;
  border-radius: 12px;
  opacity: 1;
  padding: 5px;
  cursor: pointer;
}
.vh-amount-today {
  color: green;
}
.vh-status {
  padding: 5px;
  background: #a7a7a7;
  color: #ffffff;
  border: 1px solid #a7a7a7;
  border-radius: 36px;
  opacity: 1;
}
.vh-status-today {
  padding: 5px;
  background: #21b24b;
  color: #ffffff;
  border: 1px solid #21b24b;
  border-radius: 36px;
  opacity: 1;
}

.book-ref {
  text-align: center;
  font-family: "Roboto Medium";
  font-size: 14px;
  letter-spacing: 0;
  color: #041648;
  opacity: 1;
}

.book-day {
  text-align: right;
  font-family: "Roboto Medium";
  font-size: 14px;
  letter-spacing: 0;
  color: #000000;
  opacity: 1;
}
.book-station {
  text-align: left;
  font-family: "Roboto Medium";
  font-size: 15px;
  letter-spacing: 0;
  color: #414141;
  opacity: 1;
  white-space: nowrap;
}
ion-card {
  /* height: 84px; */
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 16px;
  opacity: 1;
  cursor: pointer;
}
.rectangle {
  padding: 0px !important;
}
.vh-content {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 16px;
  opacity: 1;
}
</style>